import { products as mockProducts, categories, features, materials } from '../data/mockData';

/**
 * Returns products from localStorage (admin-managed) or falls back to mockData.
 * This ensures products created/edited in admin are visible on the shop.
 */
export function getProducts() {
  try {
    const saved = localStorage.getItem('passlux_admin_products');
    if (saved) {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch {}
  return mockProducts;
}

export { categories, features, materials };
